import { useModal } from "@/contexts";
import { MEDIA } from "@/styles/common";
import { createDate, handleDate } from "@/utils";
import {
    type onNavigateProps,
    useCheckCountState,
    useCheckFirstState,
    useCheckInState,
    useCheckMaxState,
    useCheckOutState,
    useSetCheckFakeState,
    useSetNewDataState,
} from "@shared/client";
import dayjs, { type Dayjs } from "dayjs";

export const useCheckDate = () => {
    const [isFirstClick, setIsFirstClick] = useCheckFirstState();
    const [maxDate, setMaxDate] = useCheckMaxState();
    const [checkIn, setCheckIn] = useCheckInState();
    const [checkOut, setCheckOut] = useCheckOutState();
    const setCheckFake = useSetCheckFakeState();
    const setNewData = useSetNewDataState();
    const [checkCount, setCheckCount] = useCheckCountState();
    const { closeModal } = useModal();
    const { currentObj } = createDate();
    const { isTablet } = MEDIA();

    const handleLimitedDays = (
        targetDate: Dayjs,
        date: string,
        onNavigate: ({ path, params }: onNavigateProps) => void,
    ) => {
        const differenceInDays = targetDate.diff(dayjs(checkIn), "day");
        const isWithinRange = differenceInDays <= 10;

        if (isWithinRange) {
            setCheckOut(date);
            setMaxDate(undefined);
            closeModal();

            if (isTablet) onNavigate({ path: "/reserve" });
        }

        if (!isWithinRange) {
            setCheckIn(date);
            alert("체크인 연박은 10박까지만 선택이 가능합니다.");
            setMaxDate(dayjs(date).add(10, "day"));
        }
    };

    const handleFirstClick = (date: string) => {
        setCheckIn(date);
        setCheckOut(undefined);
        setIsFirstClick(false);
        setCheckCount(1);
    };

    const onChangeColor = (date: string, onNavigate: ({ path, params }: onNavigateProps) => void) => {
        const targetDate = dayjs(date).hour(0).minute(0).second(0).millisecond(0);
        const isCurrentDateValid = currentObj.valueOf() <= targetDate.valueOf();
        const isInHighThanTarget = dayjs(checkIn).valueOf() >= targetDate.valueOf();
        setNewData(undefined);

        if (isFirstClick) {
            handleFirstClick(date);
            setMaxDate(dayjs(date).add(10, "day"));
            setCheckFake(handleDate(date, 1).newDateInfo);
        }

        if (checkCount === 0 && isCurrentDateValid) {
            setCheckCount(1);

            if (!checkOut && !isInHighThanTarget) {
                handleLimitedDays(targetDate, date, onNavigate);
            } else {
                setCheckIn(date);
                setMaxDate(dayjs(date).add(10, "day"));
                setCheckOut(undefined);
                setCheckFake(handleDate(date, 1).newDateInfo);
            }
        } else if (checkCount === 1 && isCurrentDateValid) {
            setCheckCount(0);

            if (isInHighThanTarget) {
                setCheckIn(date);
                setMaxDate(dayjs(date).add(10, "day"));
                setCheckOut(undefined);
                setCheckFake(handleDate(date, 1).newDateInfo);
            }

            if (!isInHighThanTarget) {
                if (checkOut) {
                    setCheckIn(date);
                    setMaxDate(dayjs(date).add(10, "day"));
                    setCheckOut(undefined);
                    setCheckFake(handleDate(date, 1).newDateInfo);
                } else {
                    handleLimitedDays(targetDate, date, onNavigate);
                }
            }
        }
    };

    return { checkIn, checkOut, currentObj, maxDate, onChangeColor };
};
